import React, { useState, useEffect, useRef } from 'react';
import classes from './HeaderNav.module.css';
import logo from '../../../Assets/dshbrdlogo.png';
import icon from '../../../Assets/dshbrdicon.png';
import iconinactive from '../../../Assets/dshbrd-inactive.png';
import trsanstin from '../../../Assets/cardtrsnct.png';
import trsanstinactive from '../../../Assets/trnsactn-active.png';
import acctn from '../../../Assets/Accountingicon.png';
import acctnactive from '../../../Assets/Accountingicon-active.png';
import rprts from '../../../Assets/reportsicon.png';
import rprtsactive from '../../../Assets/reportsicon-active.png';
import bnkn from '../../../Assets/bankin-icon.png';
import bnknactive from '../../../Assets/bankin-icon-active.png';
import stngs from '../../../Assets/settings-icon.png';
import stngsactive from '../../../Assets/settings-icon-active.png';
import usrnoti from '../../../Assets/notificatuin-bell.png';
import { NavLink, Link, useLocation } from "react-router-dom";
import { useUser } from '../../../UserContext';

export default function HeaderNav() {
  const location = useLocation();
  const { user, logout } = useUser();
  const [openDropdown, setOpenDropdown] = useState(null);
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const userDropdownRef = useRef(null);


  const navItems = [
    { label: 'Dashboard', path: '/dashboard', icon: iconinactive, activeIcon: icon },
    { label: 'Transactions', path: '/transactions', icon: trsanstin, activeIcon: trsanstinactive },
    { label: 'Accounting', path: '/accounts', icon: acctn, activeIcon: acctnactive },
    { label: 'Reports', path: '/report', icon: rprts, activeIcon: rprtsactive },
    { label: 'Banking', path: '/banking', icon: bnkn, activeIcon: bnknactive },
    { label: 'Inventory', path: '/inventory', icon: bnkn, activeIcon: bnknactive },
    { label: 'Settings', path: '/settings', icon: stngs, activeIcon: stngsactive },
  ];

  // Close dropdowns when clicking outside
 useEffect(() => {
  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setOpenDropdown(null);
    }
    if (userDropdownRef.current && !userDropdownRef.current.contains(e.target)) {
      setUserDropdownOpen(false);
    }
  };
  document.addEventListener('mousedown', handleClickOutside);
  return () => document.removeEventListener('mousedown', handleClickOutside);
}, []);


  return (
    <div className={classes.entnav22}>
      <img src={logo} alt="Logo" className={classes.logo} />
      <div className={classes.headerNav}>
        {navItems.map((item) => {
          const isActive = location.pathname.startsWith(item.path);
          const isDropdown = item.label === 'Transactions' || item.label === 'Settings' || item.label === 'Banking'  || item.label === 'Inventory';

          return isDropdown ? (
            <div
              key={item.label}
              className={`${classes.dshbrdnav} ${isActive ? classes.activeNav : ''}`}
            >
              {/* Dropdown toggle area */}
              <div
                className={classes.dshbrdnavMain}
                onClick={() =>
                  setOpenDropdown(openDropdown === item.label ? null : item.label)
                }
              >
                <img
                  src={isActive ? item.activeIcon : item.icon}
                  alt={`${item.label} icon`}
                  className={classes.dshbrdicon}
                />
                <p className={isActive ? classes.activeText : ''}>{item.label}</p>
              </div>

              {/* Dropdown content */}
              {openDropdown === item.label && (
                <div className={classes.dropdown} ref={dropdownRef}>

                  {item.label === 'Transactions' && (
                    <>

                      <div className={classes.dropdownItemWithSub}>
                        <span className={classes.dropdownItemLabel}>Sales Invoice</span>
                        <div className={classes.submenu}>
                          <NavLink to="/transactions/sales-invoice/customers" onClick={() => setOpenDropdown(null)}>
                           Customers
                          </NavLink>
                         
                          <NavLink to="/transactions/sales-invoice/sales" onClick={() => setOpenDropdown(null)}>
                            Sales Invoice
                          </NavLink>
                        </div>
                      </div>


                      <div className={classes.dropdownItemWithSub}>
                        <span className={classes.dropdownItemLabel}>Purchase Invoice</span>
                        <div className={classes.submenu}>
                           <NavLink to="/transactions/purchase-invoice/suppliers" onClick={() => setOpenDropdown(null)}>
                            Suppliers
                          </NavLink>
                          <NavLink to="/transactions/purchase-invoice/purchase" onClick={() => setOpenDropdown(null)}>
                            Purchase Invoice
                          </NavLink>
                        </div>
                      </div>
                      <NavLink
                        to="/transactions/payables"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Payables
                      </NavLink>

                      <NavLink
                        to="/transactions/receivables"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Receivables
                      </NavLink>

                      <NavLink
                        to="/transactions/receipts"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Receipt
                      </NavLink>
                      <NavLink
                        to="/transactions/payment"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Payment
                      </NavLink>
                    </>
                  )}

                  {item.label === 'Settings' && (
                    <>
                      <NavLink
                        to="/settings/product-services"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Products & Services
                      </NavLink>
                      <NavLink
                        to="/settings/purchase-sales"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Purchase Sales
                      </NavLink>
                    </>
                  )}

                  {/* {item.label === 'Reports' && (
                    <>
                      <NavLink
                        to="/reports/charting"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Chart of Account
                      </NavLink>
                      <NavLink
                        to="/reports/generalledger"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        General Ledgers
                      </NavLink>

                      <NavLink
                        to="/settings/purchase-sales"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Cashbook
                      </NavLink>

                      <NavLink
                        to="/settings/purchase-sales"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Trial balance
                      </NavLink>

                      <NavLink
                        to="/settings/purchase-sales"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Balance Sheet
                      </NavLink>
                    </>
                  )} */}

                  {item.label === 'Banking' && (
                    <>
                      <NavLink
                        to="/banking/pettycash"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Petty Cash
                      </NavLink>
                      <NavLink
                        to="/banking/lodgement"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Lodgement
                      </NavLink>
                      <NavLink
                        to="/banksreconcillation"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Reconciliation
                      </NavLink>

                    </>
                  )}

                  {item.label === 'Inventory' && (
                    <>
                      <NavLink
                        to="/inventory/purchase_order"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                       Purchase Order
                      </NavLink>
                      <NavLink
                        to="/inventory/stocks_delivery"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Stocks Delivery
                      </NavLink>
                      <NavLink
                        to="/inventory/payables"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Payables
                      </NavLink>

                    </>
                  )}

                   {/* {item.label === 'Reports' && (
                    <>
                      <NavLink
                        to="/reports/charting"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Chart of Account
                      </NavLink>
                      <NavLink
                        to="/reports/generalledger"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        General Ledgers
                      </NavLink>

                      <NavLink
                        to="/settings/purchase-sales"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Cashbook
                      </NavLink>

                      <NavLink
                        to="/settings/purchase-sales"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Trial balance
                      </NavLink>

                      <NavLink
                        to="/settings/purchase-sales"
                        onClick={() => setOpenDropdown(null)}
                        className={({ isActive }) =>
                          `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`
                        }
                      >
                        Balance Sheet
                      </NavLink>
                    </>
                  )} */}
                </div>
              )}
            </div>
          ) : (
            <Link to={item.path} key={item.label} className={classes.link}>
              <div className={`${classes.dshbrdnav} ${isActive ? classes.activeNav : ''}`}>
                <img
                  src={isActive ? item.activeIcon : item.icon}
                  alt={`${item.label} icon`}
                  className={classes.dshbrdicon}
                />
                <p className={isActive ? classes.activeText : ''}>{item.label}</p>
              </div>
            </Link>
          );
        })}
      </div>

      {/* User section */}
      <div className={classes.user}>
        <img src={usrnoti} className={classes.bellnoti} alt="Notification" />
        <div className={classes.userProfile} ref={userDropdownRef}>
          <div 
            className={classes.userAvatar}
            onClick={() => setUserDropdownOpen(!userDropdownOpen)}
          >
            <p className={classes.usrnm}>
              {user?.name ? user.name.split(' ').map(n => n[0]).join('').toUpperCase() : 'U'}
            </p>
          </div>
          
          {/* User dropdown menu */}
          {userDropdownOpen && (
            <div className={classes.userDropdown}>
              <div className={classes.userInfo}>
                <p className={classes.userName}>{user?.name || 'User'}</p>
                <p className={classes.userEmail}>{user?.email || 'user@example.com'}</p>
              </div>
              <div className={classes.dropdownDivider}></div>
              <NavLink 
                to="/settings" 
                className={classes.dropdownItem}
                onClick={() => setUserDropdownOpen(false)}
              >
                <img src={stngs} alt="Settings" className={classes.dropdownIcon} />
                Settings
              </NavLink>
              <button 
                className={classes.dropdownItem}
                onClick={() => {
                  logout();
                  setUserDropdownOpen(false);
                  // Redirect to signin page after logout
                  window.location.href = "/signin";
                }}
              >
                <img src={stngs} alt="Logout" className={classes.dropdownIcon} />
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
